"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParamType = exports.HttpMethod = void 0;
/**
 * OpenAPI allowed HTTP methods
 */
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["Get"] = "get";
    HttpMethod["Put"] = "put";
    HttpMethod["Post"] = "post";
    HttpMethod["Patch"] = "patch";
    HttpMethod["Delete"] = "delete";
    HttpMethod["Options"] = "options";
    HttpMethod["Head"] = "head";
    HttpMethod["Trace"] = "trace";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
/**
 * OpenAPI parameters "in"
 */
var ParamType;
(function (ParamType) {
    ParamType["Query"] = "query";
    ParamType["Header"] = "header";
    ParamType["Path"] = "path";
    ParamType["Cookie"] = "cookie";
})(ParamType = exports.ParamType || (exports.ParamType = {}));
//# sourceMappingURL=client.js.map